import React from "react";

/** The server's reason when it gave one, otherwise the fallback. */
export function errorText(error, fallback) {
  return error?.response?.data?.message || error?.response?.data?.error || fallback;
}

export const KIND_LABEL = { DEFAULT: "Certificate of completion", AHA: "AHA eCard" };

export const sessionTitle = (s, index) => `Session ${s.sessionNumber || index + 1}`;

/** The heading row of a panel: a title, a short line under it and an action on the right. Use inside `.panel`. */
export function PanelHeader({ title, subtitle, action }) {
  return (
    <div className="panel-h">
      <div style={{ minWidth: 0 }}>
        <h3>{title}</h3>
        {subtitle && <div className="sub" style={{ fontSize: 12.5 }}>{subtitle}</div>}
      </div>
      <span className="sp" />
      {action}
    </div>
  );
}

/** Pick which session an item belongs to, or "whole course". */
export function SessionSelect({ sessions, value, onChange, disabled, label = "Session" }) {
  return (
    <label className="field" style={{ minWidth: 170 }}>
      {label}
      <select className="sel" value={value ?? ""} disabled={disabled} onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}>
        <option value="">Whole course</option>
        {sessions.map((s, i) => <option key={s.id} value={s.id}>{sessionTitle(s, i)}</option>)}
      </select>
    </label>
  );
}

export function EmptyNote({ children }) {
  return <div className="sub" style={{ padding: "28px 20px", textAlign: "center", fontSize: 13.5 }}>{children}</div>;
}
